import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal, Table, UncontrolledTooltip } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import Swal from 'sweetalert2';

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

const AddPurchaseRequisition = () => {
    const history = useHistory();
    const [rows1, setrows1] = useState([{ id: 1 }]);
    const [formRows, setFormRows] = useState([{ id: 1 }]);

    const [inputs, setInputs] = useState([]);
    const [empNo, setEmpNo] = useState('');
    const [empName, setEmpName] = useState('');
    const [empTitle, setEmpTitle] = useState('');
    const [departmentcode, setDepartmentCode] = useState('');
    const [budgets, setBudgets] = useState([])
    const [currencies, setCurrencies] = useState([])
    const [locations, setLocations] = useState([])
    
    const [workPlanEntry, setWorkPlanEntry] = useState([])
    const [workplans, setWorkPlans] = useState([])
    const [gLAccounts, setGLAccounts] = useState([])
    const [wkPlanGLAccounts, setWorkPlanGLAccounts] = useState([])
    const [items, setItems] = useState([])
    const [fixedAssets, setFixedAssets] = useState([])
    const [unitOfMeasure, setUnitOfMeasure] = useState([])
    const [vendors, setVendors] = useState([])

    const [form, setForm] = useState("")
    const [subject, setSubject] = useState("")
    const [postingDate, setPostingDate] = useState("")
    const [expectedreceiptdate, setExpectedReceiptDate] = useState("")
    const [expecteddeliverydate, setExpectedDeliveryDate] = useState("")
    const [validtodate, setValidtoDate] = useState("")
    const [currencyCode, setCurrencyCode] = useState("")
    const [locationCode1, setLocationCode1] = useState("")
    const [workplanno, setWorkPlanNo] = useState("")
    const [procumentPlanReference, setProcurementPlanReference] = useState("")
    
    const [selectedType, setSelectedType] = useState('')
    const [selectedNo, setSelectedNo]= useState('')
    const [description, setDescription] = useState('')
    const [description2, setDescription2] = useState('')
    const [quantity, setQuantity] = useState(0)
    const [selectedUnitOfMeasure, setSelectedUnitOfMeasure] = useState('')
    const [directUnitCost, setDirectUnitCost] = useState(0)
    const [glcontrolacc, setGLControlAccount] = useState('')
    const [workPlanEntryNo, setWorkPlanEntryNo] = useState('')

    const [purchaseRequisitionLines, setPurchaseRequisitionLines] = useState([])

    const [noo, setNoo] = useState([])

    const [isloading, setIsloading] = useState(false);
    const [userError, setUserError] = useState(true);
    const [documentID, setDocumentID] = useState('')
    const [ipaSaved, setIpaSaved] = useState(false)
    const [ipaNo, setIpaNo] = useState('')
    const [CompanyID, setCompanyID] = useState("")

    const [modal_item, setmodal_item] = useState(false);
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
          }
          const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
          }

        toastr.options = TOAST_OPTIONS;

        const handleAddPRLine = () =>{
            setSelectedType('')
            setSelectedNo('')
            setWorkPlanEntryNo('')
            setQuantity('')
            setDescription2('')
            setDirectUnitCost('')
            tog_item()
        }

        const handleChangeWorkPlanNo = (e) => {
            let newWPNo2 = e.target.value
            if ((workplanno != '') && (e.target.value != workplanno) && (purchaseRequisitionLines.length > 0)){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Modifying the Workplan No. will delete all associated purchase requisition lines. This action is irreversible. Do you wish to proceed?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#019654',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                if (result.isConfirmed) {
                    setIsloading(true)
                    purchaseRequisitionLines.length = 0;
                    purchaseRequisitionLines.forEach((obj, index) =>{
                    handleRemoveItem(purchaseRequisitionLines) 
                    purchaseRequisitionLines.length = 0;
                }) 
                setIsloading(false)
                toastr.success('Purchase requisition lines have been cleared. Please select new workplan number and create new lines.')
                setWorkPlanNo(newWPNo2) 
                }
            })
        }
        if ((workplanno != '') && (purchaseRequisitionLines.length == 0)) {
            setWorkPlanNo(e.target.value) 
        }
        if ((workplanno == '') && (purchaseRequisitionLines.length == 0)) {
            setWorkPlanNo(e.target.value) 
        }
    }

        const handleAddItem = () =>{
            
            const itemLine =  {
                accountType     : selectedType,
                no              : selectedNo,
                description2    : description2,
                workPlanEntryNo : workPlanEntryNo,
                quantity        : parseInt(quantity),
                directUnitcost  : parseInt(directUnitCost)
            }
            setPurchaseRequisitionLines(state =>[...state, itemLine])
            tog_item()
        }
        const handleRemoveItem = (key) =>{
            const newItems = [...purchaseRequisitionLines];
            newItems.splice(key, 1);
            setPurchaseRequisitionLines(newItems);
        }
        
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const handleTypeChange = (e) =>{
            setSelectedType(e.target.value)
            setIsloading(true)
            if(e.target.value == 'Item'){
                setNoo(items)
                if(items.length > 0){ setIsloading(false) }
            }else if(e.target.value == 'Fixed Asset'){
                setNoo(fixedAssets)
                if(fixedAssets.length > 0) { setIsloading(false) }
            }else if(e.target.value == 'G/L Account'){
                fetchWorkplanGLAccounts()
            }else{
                setNoo([])
                setIsloading(false)
            }
        }
        const handleNoChange = (e)=>{
            setSelectedNo(e.value); 
            if(selectedType == 'Item'){
                fetchItemWorkplanEntryNo(e.value);
            }
            if(selectedType == 'G/L Account'){
                fetchGLWorkplanEntryNo(e.value);
            }
            if(selectedType == 'Fixed Asset'){
                fetchFAWorkplanEntryNo(e.value);
            }
        }
        const handleSubmit = (event) => {
            if (workplanno == ""){
                toastr.error("Workplan No. must not be blank!")
            } else if (locationCode1 == ""){
                toastr.error("Location code must not be blank!")
            } else if (expectedreceiptdate == ""){
                toastr.error("Expected receipt date must not be blank!")
            } else if (subject == ""){
                toastr.error("Subject of procurement must not be blank!")
            } else if (expecteddeliverydate == ""){
               toastr.error("Delivery Date must not be blank!")
            } else{
                setIsloading(true); 
                const data = {
                    
                    requestorNo             :   empNo,
                    documentType            :   'Purchase Requisition',
                    workPlanNo              :   workplanno,
                    ProcumentPlanReference  :   procumentPlanReference,  
                    locationCode            :   locationCode1,          
                    procurementType         :   form,
                    expectedReceiptDate     :   expectedreceiptdate,
                    expectedDeliverytDate   :   expecteddeliverydate,
                    procurementDescription  :   subject,
                    purchaseRequisitionLines:   purchaseRequisitionLines
                };
            
                axios.post(url.PURCHASES1 +"?company="+ CompanyID, JSON.stringify(data), HRConfig)
                    .then(function(response){  
                        if(response.status == '201'){
                            setDocumentID(response.data.id)
                            toastr.success("Purchase Requisition No "+ response.data.no+" created successfully!" ); 
                            setTimeout(function(){ history.push(`/purchase-requisition-details/${response.data.id}`)} ,3000 );
                        }else{
                            toastr.error("Could not Create Purchase Requisition!!" )
                            setIsloading(false);
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                        toastr.error(error.response.data.error.message);
                        setIsloading(false);
                    })
                    .then(function () {                
                });
            } 
        }

        const fetchGLWorkplanEntryNo = (newNo) => {
            axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`, HRConfig).then((r)=>{
                setWorkPlanEntry(r.data.value);
                }).catch((e)=>{ 
                    console.log(e); 
                    setIsloading(false) 
                })
        }
        const fetchItemWorkplanEntryNo = (newNo) => {
            axios.get(url.ITEMS + "?$filter=no eq '"+ newNo +"'&company="+ CompanyID, HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        setGLControlAccount(response.data.value[0].GLControlAccount)
                        axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`, HRConfig).then((r)=>{
                            setWorkPlanEntry(r.data.value);
                            }).catch((e)=>{ 
                                console.log(e); 
                                setIsloading(false) 
                        })
                }
            })
        }
        const fetchFAWorkplanEntryNo = (newNo) => {
            axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`, HRConfig).then((r)=>{
                setWorkPlanEntry(r.data.value);
                }).catch((e)=>{ 
                    console.log(e); 
                    setIsloading(false) 
                })

                axios.get(url.FIXEDASSETS + "?$filter=no eq '"+ newNo +"'&company="+ CompanyID, HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        setGLControlAccount(response.data.value[0].GLControlAccount)
                        axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`, HRConfig).then((r)=>{
                            setWorkPlanEntry(r.data.value);
                            }).catch((e)=>{ 
                                console.log(e); 
                                setIsloading(false) 
                        })
                }
            })
        }

        const fetchWorkplanGLAccounts = async() => {
            axios.get(`${url.WORKPLANGLACCOUNTS}?$filter=workPlanNo eq '${workplanno}' &company=${CompanyID}`, HRConfig).then((r)=>{
                let options = []
                r.data.value.map((a)=>{options.push({value:a.gLAcccount, label:`${a.gLAcccount} ${': '}${a.accountName}`})})
                setNoo(options);
                setWorkPlanGLAccounts(options);
               
                if(wkPlanGLAccounts.length > 0) { setIsloading(false) }
                setIsloading(false)
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
        }

        useEffect(() => {
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                const EmployeeNo = obj.uid;
                setCompanyID(obj.activeCompany); 
                axios.get(url.EMPLOYEES2 + "?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setDepartmentCode(response.data.value[0].Department_Code);
                            setUserError(false);

                            axios.get(url.LOCATIONS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{ 
                                setLocations(r.data.value);
                                }).catch((e)=>{ 
                                    console.log(e)
                                    setIsloading(false) 
                            })
                            axios.get(`${url.WORKPLANS}?$filter=department eq '${response.data.value[0].Department_Code}' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                                setWorkPlans(r.data.value);
                                }).catch((e)=>{ 
                                    console.log(e); 
                                    setIsloading(false) 
                            })
                            axios.get(url.GLACCOUNTS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{ 
                                let options = []
                                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.no} ${': '} ${a.name}`})})
                                setGLAccounts(options)
                                }).catch((e)=>{ 
                                    console.log(e)
                            })
                            axios.get(url.ITEMS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{ 
                                let options = []
                                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.no} ${': '} ${a.description}`})}) 
                                setItems(options)
                                }).catch((e)=>{ 
                                    console.log(e)
                            })
                            axios.get(url.FIXEDASSETS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{ 
                                let options = []
                                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.no} ${': '} ${a.description}`})})  
                                setFixedAssets(options)
                                }).catch((e)=>{ 
                                    console.log(e)
                            })
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                        console.log(error);
                })
                    
            }
        },[]);
        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Purchase Requisition | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Purchase Management" breadcrumbItem="Purchase Requisition" />
                        <div>
                        {userError && ( 
                        <Alert color="danger" role="alert">
                            Your Employee Number Not Found in Dynamics 365 Business Central
                        </Alert>
                        )}

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                                <CardTitle>Employee Details</CardTitle>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th scope="col"> Number</th>
                                                    <td scope="col"> {empNo} </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col"> Name</th>
                                                    <td scope="col">{empName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Position</th>
                                                    <td scope="col">{empTitle}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Department</th>
                                                    <td scope="col">{departmentcode}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                 
                                </CardBody>
                            </Card>
                            <div className="d-flex">
                                <div className="flex-grow-1 ms-1">                                 
                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            {/* {(workplanno != "") && (locationCode1 != "") && (subject != "") && (expectedreceiptdate != "") && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddPRLine()}} >
                                                    <i className="mdi mdi-cart-arrow-down"/>{" "}
                                                    Add Purchase Requisition Line
                                                </Button>
                                            )} */}
                                            {(purchaseRequisitionLines.length > 0) && (
                                                <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleSubmit}>
                                                    <i className="mdi mdi-content-save-all-outline"/>{" "}
                                                        Save Purchase Requisition
                                                </Button>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle>Requisition Details</CardTitle>
                                <div className="table-responsive">
                                    <Row>
                                        <Col md={12}>
                                        <table className="table">
                                        
                                            <tbody>
                                                <tr>
                                                    <th scope="col"> Work Plan No.</th>
                                                    <td scope="col">
                                                    <select className="form-select" value={workplanno} 
                                                        //onChange={(e)=>setWorkPlanNo(e.target.value)}
                                                        onChange={(e)=>handleChangeWorkPlanNo(e)}
                                                        > 
                                                        <option value=''>Select</option>
                                                            { workplans.map((l,k)=>( <option key={k} value={l.no}>{l.no}
                                                        </option> ))}
                                                    </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Proc. Plan Reference</th>
                                                    <td scope="col">
                                                        <p className="text-muted fs-14 mb-0">
                                                            <input 
                                                                className="form-control" 
                                                                type="text" 
                                                                value={procumentPlanReference} 
                                                                onChange={(e)=>setProcurementPlanReference(e.target.value)}
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Location Code</th>
                                                    <td scope="col">
                                                        <select className="form-select" value={locationCode1} onChange={(e)=>setLocationCode1(e.target.value)}> 
                                                            <option value=''>Select</option>
                                                                { locations.map((l,k)=>( <option key={k} value={l.code}>{l.name}
                                                            </option> ))}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col"> Expected Receipt Date</th>
                                                    <td scope="col">
                                                    { <Flatpickr
                                                            className="form-control"
                                                            value={expectedreceiptdate}
                                                            onChange={(e)=>setExpectedReceiptDate(formatDate(e))}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d",
                                                                disabled: true

                                                            }}
                                                        /> }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Expected Delivery Date</th>
                                                    <td scope="col">
                                                    { <Flatpickr
                                                            className="form-control"
                                                            value={expecteddeliverydate}
                                                            onChange={(e)=>setExpectedDeliveryDate(formatDate(e))}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d",
                                                                disabled: true,
                                                                defaultDate: 'today'
                                                            }}
                                                    /> }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Procurement Type</th>
                                                    <td scope="col">
                                                        <select className="form-select" value={form} onChange={(e)=>setForm(e.target.value)}>
                                                            <option value="">Select</option>
                                                            <option value="Contracts">Contracts</option>
                                                            <option value="LPO">LPO</option>
                                                            <option value="Direct Invoice">Direct Invoice</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                        </Col>
                                    </Row>  
                                    <Col md={12}>
                                    <label htmlFor="floatingDepartInput"> <h6> {" "}Subject of Procurement</h6></label>
                                        <div className="form-floating mb-3">
                                            <input  type="text" className="form-control" onChange={(e)=>setSubject(e.target.value)} value={subject}   />
                                        </div>
                                </Col>                                 
                            </div>
                        <Row>
                    </Row>
                </CardBody>
            </Card>

            <Col xl={12}>
                <Card>
                    <CardBody>
                        <CardTitle className= "mb-3 mt-1">
                            <Row className='mb-2'>
                                        <Col sm={6}>
                                            Purchase Requisition Lines ({purchaseRequisitionLines.length})
                                        </Col>

                                        {(workplanno != '') && (locationCode1 != '') && (expectedreceiptdate != '') && (subject != '') && (
                                            <Col sm={6}>
                                                <div className='text-sm-end'>
                                                    <Button 
                                                        color="primary" 
                                                        className="btn btn-primary btn-label waves-effect waves-light"
                                                        onClick={()=>{handleAddPRLine()}}
                                                    >
                                                        <i className="mdi mdi-cart-arrow-down label-icon"/>{" "}
                                                            Add Purchase Requisition Line
                                                    </Button>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                        </CardTitle>

                    <CardBody className="border-bottom">
                        {(purchaseRequisitionLines.length > 0) ? (
                            <div className="table-responsive">
                                <Table  className="table table-striped table-sm mb-4">
                                    <thead>
                                        <tr>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Type</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>No</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>WorkPlan Entry No</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description 2</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Quantity</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Estimated Unit Cost</th>
                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>   
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseRequisitionLines.map((a, k)=>(
                                            <tr key={k}>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.accountType}</td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.no}</td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.workPlanEntryNo}</td> 
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.description2}</td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.quantity.toLocaleString("en-UG")}</td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.directUnitcost.toLocaleString("en-UG")}</td> 
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> </td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                    <div className="d-flex gap-3">     
                                                        <Link
                                                            to="#"
                                                            className="text-danger"
                                                            onClick={() => handleRemoveItem(k)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                Delete
                                                            </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                </Table>
                                </div>
                            ):(
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-cart-arrow-down text-warning display-4" />
                                    </div>
                                    <div>
                                    <h5>No Purchase Requisition Lines added, yet!</h5>
                                    <p className="text-muted">
                                            
                                    </p>
                                    </div>
                                </div>
                    )}
                </CardBody>

            <Modal isOpen={modal_item} toggle={() => {tog_item()}} size="l" centered backdrop={'static'} >
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myModalLabel">Add Requisition Line</h5>
                    <button type="button" onClick={() => { setmodal_item(false)}} className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row >
                        <Col lg={12}>
                        <label htmlFor="floatingDepartInput">Type</label>
                            <div className="form-floating mb-3">
                                <select className="form-select" value={selectedType} onChange={(e) =>{handleTypeChange(e)} }>
                                <option value=" ">Select</option>
                                <option value="G/L Account">G/L Account</option>
                                <option value="Item">Item</option>
                                <option value="Fixed Asset">Fixed Asset</option></select>
                            </div>
                        </Col>
                    
                        {((selectedType == 'G/L Account')||(selectedType == 'Item')||(selectedType == 'Fixed Asset')) && (
                        <Col lg={12}>
                        <label htmlFor="floatingSelectGrid">No</label>
                            <div className="form-floating mb-3">
                                <Select options={noo} 
                                    value={noo.find((option) => option.value === selectedNo)} 
                                    onChange={handleNoChange} 
                                />
                            </div>                                             
                        </Col>
                        )}
                        
                        <Col lg={12} className="mb-3">
                            <label htmlFor="floatingSelectGrid">Workplan Entry No</label>
                            <select className="form-select" value={workPlanEntryNo} onChange={(e)=>setWorkPlanEntryNo(e.target.value)}> 
                                <option value=''>Select</option>
                                    { workPlanEntry.map((l,k)=>( <option key={k} 
                                        value={l.entryNo}>{l.entryNo}
                                </option> 
                                ))}
                                </select>
                        </Col>

                        <Col lg={12}>
                        <label htmlFor="floatingSelectGrid">Description 2</label>
                        <div className="form-floating mb-3">
                            <input  type="text" className="form-control" onChange={(e)=>setDescription2(e.target.value)}   />
                        </div>
                        </Col>

                        <Col lg={6}>
                            <label htmlFor="floatingSelectGrid">Quantity</label>
                                <div className="form-floating mb-3">
                                    <input  type="number" className="form-control" value={quantity}  onChange={(e)=>{ setQuantity(e.target.value)}} />
                                </div>
                        </Col>

                        <Col lg={6}>
                            <label htmlFor="floatingSelectGrid">Unit Cost</label>
                                <div className="form-floating mb-3">
                                    <input  type="number" className="form-control" value={directUnitCost} onChange={(e)=>{ setDirectUnitCost(e.target.value)}}  />
                                </div>
                        </Col>      
                    </Row>        
                </div>
                <div className="modal-footer">
                    {(directUnitCost != "") && (directUnitCost > 0 ) && (quantity != "") && (quantity > 0) && (selectedType != "") && (workPlanEntryNo != "") && (selectedNo != "") && (
                        <Button color="primary" type="button" className="btn btn-primary" onClick={handleAddItem}>
                            <i className="mdi mdi-content-save-all-outline"/>{" "}
                                Save Line
                        </Button>
                    )}
                </div>
            </Modal>  
        </CardBody>
    </Card>
</Col>
            <br/>
        </Col>
        </Row>
        ):(
            <Row className="d-flex justify-content-center">
                <Col lg={8} >
                <Card outline color="success" className="border">
                    <CardBody>
                    <CardTitle className="mb-4 text-white">
                        
                    </CardTitle>
                    <CardText>
                        
                    </CardText>
                    <div className="text-center">
                        <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                        <h5>Saved</h5>
                        <p className="text-muted">
                                Requisition <strong>{ipaNo}</strong> Saved!
                        </p>
                        </div>
                    </div>
                    </CardBody>
                </Card>
                </Col>
            </Row>
        )}
        </div>


        
            

    </Container>
</div>
</LoadingOverlay>


);
}

export default AddPurchaseRequisition;